import { api } from './client'

// ============================================================================
// Danh mục sản phẩm (#M-16) — phân nhóm sản phẩm theo cách đóng gói.
//
// Các sổ ghi chép của xưởng lọc sản phẩm theo MÃ danh mục, nên mã là khoá nối
// giữa sổ và sản phẩm: danh mục hệ thống đổi tên được, đổi mã và xoá thì không.
// ============================================================================

/** Mã danh mục hệ thống — dùng hằng, không gõ chuỗi rải rác trong màn hình. */
export const PRODUCT_CATEGORY_TUI_12_5G = 'TUI_12_5G'
export const PRODUCT_CATEGORY_TUI_KHAC = 'TUI_KHAC'
export const PRODUCT_CATEGORY_HOP = 'HOP'

export interface ProductCategory {
    id: string
    code: string
    name: string
    sort_order: number
    is_active: boolean
    /** Danh mục các sổ phụ thuộc: đổi tên được, không xoá được. */
    is_system: boolean
    /** Số sản phẩm đang xếp trong danh mục (chỉ có ở danh sách). */
    products_count: number
    created_at: string
    updated_at: string
}

export interface ListProductCategoriesParams {
    is_active?: boolean
    search?: string
}

export interface CreateProductCategoryRequest {
    code: string
    name: string
    sort_order?: number
    /** Bỏ trống = tạo ở trạng thái đang dùng. */
    is_active?: boolean
}

export interface PatchProductCategoryRequest {
    code?: string
    name?: string
    sort_order?: number
    is_active?: boolean
}

const BASE = '/product-categories'

export const productCategoryApi = {
    list: (params?: ListProductCategoriesParams) =>
        api.get<ProductCategory[]>(BASE, {
            params: params as Record<
                string,
                string | number | boolean | undefined
            >,
        }),
    get: (id: string) => api.get<ProductCategory>(`${BASE}/${id}`),
    create: (data: CreateProductCategoryRequest) =>
        api.post<ProductCategory>(BASE, data),
    patch: (id: string, data: PatchProductCategoryRequest) =>
        api.patch<ProductCategory>(`${BASE}/${id}`, data),
    remove: (id: string) => api.delete<{ status: string }>(`${BASE}/${id}`),
}
